const prodUrl = "https://instructor-tools-api.herokuapp.com/students";
const devUrl = "http://localhost:3000/students";


let apiUrl = prodUrl;

export default apiUrl;